import { useMemo } from 'react';

import { isPhone } from '@helpers';
import { DashboardOverviewDateRange } from '@reducers/v2/dashboard/types';
import type { DropdownItem } from '@components/common/dropdown/types';

import { dashboardOverviewDateRangeLabels, dashboardOverviewExtendedDateRangeLabels } from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewHeader/components/DashboardOverviewDateRangePicker/constants';
import type { DashboardOverviewDateRangeMoreSelectorProps } from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewHeader/components/DashboardOverviewDateRangePicker/components/DashboardOverviewDateRangeMoreSelector';

interface UseManageDashboardOverviewDateRangeMoreSelectorParams
  extends Pick<DashboardOverviewDateRangeMoreSelectorProps, 'selectedDateRange'> {}

export const useManageDashboardOverviewDateRangeMoreSelector = ({
  selectedDateRange,
}: UseManageDashboardOverviewDateRangeMoreSelectorParams) => {
  const items: DropdownItem<DashboardOverviewDateRange>[] = useMemo(
    () =>
      (Object.entries(dashboardOverviewExtendedDateRangeLabels) as [DashboardOverviewDateRange, string][]).map(([value, label]) => ({
        value,
        label,
      })),
    []
  );

  const isExtendedOnly = isPhone || !(selectedDateRange in dashboardOverviewDateRangeLabels);
  const triggerLabel = isExtendedOnly ? dashboardOverviewExtendedDateRangeLabels[selectedDateRange] : 'More';

  return {
    items,
    isExtendedOnly,
    triggerLabel,
  };
};
